import React, { useEffect } from 'react';
import { Typography, Box, Button, Alert, Stack, InputLabel } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { multiFactor } from 'firebase/auth';
import { StatusDisplay } from './StatusDisplay';

const SecurityItem = ({ title, status, description, action, alert }) => (
  <Stack spacing={1} sx={{ mb: 2 }}>
    <InputLabel sx={{ fontWeight: '700' }}>{title}</InputLabel>
    {description && <Typography>{description}</Typography>}

    {alert && (
      <Alert severity={alert.severity} sx={{ my: 1 }}>
        {alert.message}
      </Alert>
    )}
    <Box>{action}</Box>
  </Stack>
);

export const SecurityOverview = ({ onResendVerification }) => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Check MFA status using multiFactor
  const hasMfa = currentUser ? multiFactor(currentUser).enrolledFactors.length > 0 : false;
  const isEmailVerified = currentUser?.emailVerified;

  // Show success message if redirected from MFA setup
  useEffect(() => {
    if (location.state?.mfaEnabled) {
      // Clear the location state to prevent showing the message again on refresh
      navigate(location.pathname, { replace: true });
    }
  }, [location.state, navigate, location.pathname]);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="sectionHeader" compnent="h3">
        Security
      </Typography>

      <Stack
        spacing={3}
        direction="column"
        sx={{ mt: 2, alignItems: 'flex-start', justifyContent: 'flex-start' }}
      >
        {/* Email Verification Status */}
        {/* <SecurityItem
          title="Email Verification"
          description={<><span>Status:</span> <StatusDisplay isVerified={isEmailVerified} verifiedText="Verified" /></>}
          action={
            !isEmailVerified && (
              <Button 
                variant="contained" 
                onClick={onResendVerification}
              >
                Verify Email
              </Button>
            )
          }
          alert={
            !isEmailVerified && {
              severity: "warning",
              message: "Please verify your email address to enable additional security features."
            }
          }
        /> */}

        {/* Phone Number Status */}
        <SecurityItem
          title="Phone Number"
          description={
            <>
              <span>Status:</span>{' '}
              <StatusDisplay isVerified={currentUser?.phoneNumber} verifiedText="Linked" />
            </>
          }
          action={null}
          alert={
            !currentUser?.phoneNumber && {
              severity: 'info',
              message: 'Link a phone number to enable two-factor authentication.',
            }
          }
        />

        {/* MFA Status */}
        <SecurityItem
          title="Two-Factor Authentication"
          description="Requires verified Email &amp; Linked Telephone to add extra security to your account."
          action={
            hasMfa ? (
              <Button
                variant="outlined"
                color="error"
                onClick={() => navigate('/settings/mfa/disable')}
                sx={{ borderWidth: '2px', display: 'inline-block' }}
              >
                Disable Two Factor Authentication
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate('/settings/mfa/setup')}
                disabled={!isEmailVerified}
                sx={{ borderWidth: '2px', padding: '16px 48px', display: 'inline-block' }}
              >
                Enable Two Factor Authentication
              </Button>
            )
          }
          alert={
            !hasMfa &&
            isEmailVerified && {
              severity: 'info',
              message: 'Enhance your account security by enabling two-factor authentication.',
            }
          }
        />
      </Stack>
    </Box>
  );
};
